import { BootInstallationSwitch } from '@/layouts/consts'
import { Button } from '@/plugins/ant-design-vue/tsx-support'
import { Component, Mixins, Watch } from '@/vue-property-decorator'
import { createSvgSprite } from '@/utils/business-utils/assets'
import { useDownloadAppStore } from '@/layouts/components/downloadApp/store'
import { useMainStore } from '@/store/index'
import { windowConfig } from '@/utils/window'
import BaseMixins from './mixin/index'
import BusinessUtils from '@/utils/business-utils'
import Modal from '@/controller/Modal'
import TooltipsComp from '@/components/business-components/tooltips'
import isMobile from '@/utils/isMobile'
import style from './style.module.scss'
/**通过站点配置开启APP提示触发该弹出框 */
@Component<DownlodAppBySite>({ name: 'DownlodAppBySite' })
export default class DownlodAppBySite extends Mixins(BaseMixins) {
  /**配置站点信息是否展示提示APP下载 */
  private static get showDownloadAppFromSite() {
    const { brandLogoInfos } = useMainStore()
    const showSuggestDownloadApp = false
    if (!brandLogoInfos) {
      return false
    }
    const { bootInstallationSwitch } = brandLogoInfos
    const { APP } = BootInstallationSwitch
    if (bootInstallationSwitch === APP) {
      return true
    }
    return showSuggestDownloadApp
  }
  get routerName() {
    return this.$route.name
  }

  get hasCallApiGetActiveRewardBindBeforeLogin() {
    return useDownloadAppStore().hasCallApiGetActiveRewardBindBeforeLogin
  }

  @Watch('hasCallApiGetActiveRewardBindBeforeLogin')
  callDownloadAppBySite() {
    const { isWeb } = useMainStore()
    if (windowConfig.speedPackageConfig || isWeb) {
      return
    }

    if (!this.hasCallApiGetActiveRewardBindBeforeLogin) {
      return
    }
    if (DownlodAppBySite.showDownloadAppFromSite) {
      this.downloadAppBySite()
    }
  }

  @Watch('routerName')
  dispatchDownloadApp() {
    const { isWeb } = useMainStore()
    if (windowConfig.speedPackageConfig || isWeb) {
      return
    }

    // 是否是强制安装，同时开启类型是提示APP下载
    const isForce = useDownloadAppStore().isForceInstallation
    if (DownlodAppBySite.showDownloadAppFromSite && isForce) {
      this.downloadAppBySite()
    }
  }

  /**通过站点配置，自动弹出下载APP */
  private async downloadAppBySite() {
    const { downloadAppReward } = useMainStore()
    const { isSiteCurrencyBelongNewRewardsCurrency } = useDownloadAppStore()
    const formatedDownloadAppReward = this.formatDownloadAppReward
    const urlslist = await useDownloadAppStore().getDownloadConfig(
      this.downloadAppBySite
    )
    const { brandLogoInfos } = useMainStore()
    Modal.create({
      closable: true,
      hiddenBtns: true,
      class: style.downloadModal,
      width: BusinessUtils.px2rem(600),
      content: () => {
        return (
          <div class={style.downloadContent}>
            <div class={style.logo}>
              <my-img src={brandLogoInfos?.appIconBigPath ?? ''} />
              <span class={style.title}>
                {brandLogoInfos?.installationHint ?? ''}
              </span>
            </div>
            <div
              class={style.wrapperUrlslist}
              ref={'downloadBtnRef'}
              data-clipboard-text={this.getClipBoardParams}
            >
              {urlslist?.map((item, index) => {
                let count = 0
                return (
                  <Button.Tsx
                    key={item.name}
                    type="primary"
                    ghost={!(index % 2)}
                    class={style.downloadItem}
                    onClick={() => {
                      this.handlerDownloadBtn(item, count)
                      count++
                    }}
                  >
                    {!!downloadAppReward &&
                      isSiteCurrencyBelongNewRewardsCurrency && (
                        <TooltipsComp
                          charge={1}
                          top={BusinessUtils.px2rem(-20)}
                          text={formatedDownloadAppReward}
                        />
                      )}
                    <icon-sprite
                      class={style.appIcon}
                      sprite={
                        isMobile().apple.device
                          ? createSvgSprite('comm_icon_xz-ios')
                          : createSvgSprite('comm_icon_xz-android')
                      }
                    />
                    <span class={style.appName}>{item.name}</span>
                  </Button.Tsx>
                )
              })}
            </div>
          </div>
        )
      }
    })
    this.$nextTick(this.createClipBoard)
  }

  render() {
    return <template></template>
  }
}
